export default "__VITE_ASSET__Cn8aJ2FH__"